<mat-toolbar class="mat-elevation-z4 custom-toolbar" color="primary">
    <a href='/' class='title'>Disputes Dashboard</a>
    <div class='toolbar-spacer'></div>
    <button mat-raised-button *ngIf="!isUserLoggedIn" (click)='login()'>Login</button>
    <button mat-raised-button *ngIf="isUserLoggedIn" (click)='logout()'>Logout</button>
</mat-toolbar>